import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

const Translate = ({ i18nKey, options }) => {
  const { t } = useTranslation();
  return React.createElement(Fragment, null, t(i18nKey, options));
};

export { Translate };
